import * as React from "react";
import { getBexApiContext } from "bernie-context";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { ContextInput } from "__generated__/api";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export interface TripsBexApiComponentProps {
  inputs: {
    context?: ContextInput;
    flexContext: ExtendedContextStore;
  };
}

/**
 * Used to wrap Shared UI or Bex API components.
 *
 * See PropertyReviewsWrapper or PropertyReviewsHeadline for example.
 * @param Component
 * @param additionalInputs
 * @constructor
 */
export const TripsBexApiWrapper = (Component: React.ComponentType<any>, additionalInputs?: any) => (
  props: ComponentProps
) => {
  const context = props.context;

  if (!context) {
    return null;
  }

  const inputs = {
    context: getBexApiContext(context),
    ...additionalInputs,
    flexContext: context,
  };

  return <Component inputs={inputs} />;
};
